import { alpha } from "@mui/material/styles";

// Constants
import { BORDER_RADIUS, BUTTON_BORDER_RADIUS } from "Constants/theme";

export const styles = {
  appointmentCard: (colour) => ({
    width: "100%",
    boxSizing: "border-box",
    minWidth: "300px",
    border: 2,
    borderColor: colour,
    backgroundColor: colour,
    borderRadius: BORDER_RADIUS,
    "&.MuiPaper-root": { pl: 2, pr: 0, py: 0 },
  }),
  appointmentStack: { width: "100%", backgroundColor: "background.paper" },
  detailsStack: {
    boxSizing: "border-box",
    justifyContent: "center",
    alignItems: { xs: "flex-start", md: "center" },
    p: 1,
  },
  infoStack: {
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    pb: 1,
  },
  clinicTitle: { fontSize: 17, fontWeight: "bold", textAlign: "left" },
  statusButton: (colour) => ({
    alignItems: "center",
    borderRadius: BUTTON_BORDER_RADIUS,
    color: colour,
    columnGap: 1,
    display: "inline-flex",
    height: "fit-content",
    px: 1.5,
    py: 0.5,
    mb: 1,
    backgroundColor: alpha(colour, 0.12),
  }),
  actionStack: {
    width: { xs: "100%", md: "fit-content" },
    minWidth: "45%",
    alignItems: "center",
    justifyContent: "flex-end",
    py: { xs: 1, sm: 0 },
  },
};
